import { ReactElement } from 'react';

const FVSStep10AlertContent1 = (): ReactElement => (
  <div>
    If the application is successful the fines will be withdrawn by the enforcement agency. Any demerit points associated with the fine will also be withdrawn. You will not have to
    take any further action for that fine.
  </div>
);

export default FVSStep10AlertContent1;
